import React, {Component} from 'react';

import {Editor as TextEditor} from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import Config from "../Helpers/Config";
import axios from 'axios';
import { EditorState,convertToRaw, ContentState } from 'draft-js';

import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';

export default class Editor extends Component {

    constructor(props) {
        super(props);


        let contentBlock  = htmlToDraft(`<p>${props.value}</p>`);

        const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
        const editorState = EditorState.createWithContent(contentState);


        this.state = {
            editorState:editorState,
            value:""
        };
        this.onChange = this.onChange.bind(this)
        this.uploadFile = this.uploadFile.bind(this)
    }

    render() {
        return (
            <div>
                {

                     <TextEditor
                     disabled={this.props.disabled}
                     toolbar={{
                     image: {uploadCallback: this.uploadFile, alt: {present: true, mandatory: false}}
                     }}
                     editorState={this.state.editorState}
                     onEditorStateChange={this.onChange}/>

                }
            </div>
        )
    }

    onChange = (editorState) => {
        this.setState({editorState});
        let value = draftToHtml(convertToRaw(editorState.getCurrentContent()));
        if (this.props.onChange) {
            this.props.onChange(value);
        }
    };




    uploadFile(file) {

        let data = new FormData();
        let CancelToken = axios.CancelToken;
        let source = CancelToken.source();

        data.append('file', file);

        let config = {
            withCredentials: Config.withCredentials(),
            cancelToken: source.token
        };


        let response = axios.post(Config.api() + 'upload-file', data, config)

            .then((response) => {
                if (!response.data.status || response.data.status !== true) {
                    return;
                }
                response.data.link = response.data.file.fullUrl

                return response
            })
            .catch((error) => {
                // if (error.response.status === 401) {
                //     this.props.requiresReLogin();
                // } else {
                //     NotificationManager.error(error.message, file.name);
                // }
                // let index = this.findFileIndex(file)
                // this.updateFileByIndex(index, 'is_valid', false)
            });


        return  response;
    }

}